// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/DirectMessagesImport';
export class SourceCollection {
    constructor(collection) {
        this.routeID = null;
        this.cache = {};
        if (collection) {
            this.Update(collection);
        }
    }
    Update(collection) {
        const cache = collection.cache;
        for (const key in cache) {
            const item = cache[key];
            this.AddSource(key, item.Name, item.ExternalId);
        }
    }
    AddSource(id, name, externalId) {
        const src = new Source(id, name, externalId);
        this.cache[src.Id] = src;
    }
    GetSourceName(id) {
        const source = this.getSource(id);
        return source ? source.Name : id.toString();
    }
    getSource(id) {
        return this.cache[id];
    }
    UpdateByMessage(msg) {
        if (!msg || msg.Code != Message.CODE_SOURCE_LIST) {
            return;
        }
        this.routeID = msg.RouteId;
        if (msg.SourceIDs) {
            for (let i = 0; i < msg.SourceIDs.length; i++) {
                this.AddSource(msg.SourceIDs[i], msg.SourceNames[i], msg.SourceExternalIds[i]);
            }
        }
    }
}
export class Source {
    constructor(id, name, externalId) {
        this.Id = id;
        this.Name = name;
        this.ExternalId = externalId;
    }
}
